/**
 * South African registration reference data for the FICA/KYC form.
 * This is a licensed SA bookmaker — registrants are South African residents,
 * so province is an SA-only field and country is fixed to ZA server-side.
 */
export const SA_PROVINCES: string[] = [
  'Eastern Cape',
  'Free State',
  'Gauteng',
  'KwaZulu-Natal',
  'Limpopo',
  'Mpumalanga',
  'Northern Cape',
  'North West',
  'Western Cape',
];

export const SOURCE_OF_FUNDS: string[] = [
  'Salary',
  'Business',
  'Savings',
  'Other',
];
